module.exports = __webpack_public_path__ + "img/decor1.90019be9.svg";